import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class UsersDataSource {
  disable2fa(data: any) {
	let url = `${environment.apiUrl}/user/disable/2fa`;
	return this.retPipe(this.http.post<any>(url, data))
  }
  setup2fa() {
    let url = `${environment.apiUrl}/user/setup/2fa`;
	return this.http.get<any>(url);
  }
  verify2fa(data: any) {
    let url = `${environment.apiUrl}/user/setup/2fa`;
	return this.retPipe(this.http.post<any>(url, data))
  }
  checkCoupon(value: string) {
    let url = `${environment.apiUrl}/user/coupon/${value}`;
	return this.http.get<any>(url);
  }
  getNotifications(filters?: { unread?: boolean; date_from?: string; date_to?: string }) {
	let url = `${environment.apiUrl}/user/notifications`;
	let params = new HttpParams();
	if (filters) {
	  // El backend espera '1'/'0', no 'true'/'false'.
	  if (filters.unread !== undefined) params = params.append('unread', filters.unread ? '1' : '0');
	  if (filters.date_from) params = params.append('date_from', filters.date_from);
	  if (filters.date_to) params = params.append('date_to', filters.date_to);
	}
	return this.http.get<any>(url, { params });
  }
  postReadNotifications(notifications_id: any) {
	let url = `${environment.apiUrl}/user/notifications`;
	return this.retPipe(this.http.post<any>(url, notifications_id))
  }
  deleteUserPhoto(id: any) {
	let url = `${environment.apiUrl}/user/profile/photo/${id}`;
	return this.http.delete<any>(url);
  }
  getUserPhotos() {
	let url = `${environment.apiUrl}/user/profile/photo`;
	return this.http.get<any>(url);
  }
  getUserCustomer(){
	let url = `${environment.apiUrl}/user/customer`;
    return this.http.get<any>(url);
  }
  getUserTeam() {
	let url = `${environment.apiUrl}/user/team`;
	return this.http.get<any>(url);
  }
  deleteUserMeta(id: number) {
	let url = `${environment.apiUrl}/user/meta/${id}`;
	return this.retPipe(this.http.delete<any>(url))
  }
  postUserMeta(phones: any) {
	let url = `${environment.apiUrl}/user/meta`;
	return this.retPipe(this.http.post<any>(url, phones))
  }
  // Bitácora de auditoría — ver DownloadFrictionService ("Descargar resumen"). event/type/name/id
  // son todos string; id y name son opcionales si la acción no aplica a un objeto puntual.
  postUserEvent(data: { event: string; type?: string; name?: string; id?: string }) {
	let url = `${environment.apiUrl}/user/event`;
	return this.retPipe(this.http.post<any>(url, data))
  }
  getUserOrganization() {
	let url = `${environment.apiUrl}/user/organization`;
	return this.http.get<any>(url);
  }
  putUserOrganization(data: any) {
	let url = `${environment.apiUrl}/user/organization`;
	return this.retPipe(this.http.put<any>(url, data))
  }

  getUserPlan() {
	let url = `${environment.apiUrl}/user/plan`;
	return this.retPipe(this.http.get<any>(url))
  }
	constructor(
		private http: HttpClient
	) {}
	postPurchasePlan(value: any) {
		let url = `${environment.apiUrl}/user/plan`;
		return this.retPipe(this.http.post<any>(url, value))
	}
	putUserPlan(data: { plan_id: any; user_licenses: number }) {
		let url = `${environment.apiUrl}/user/plan`;
		return this.retPipe(this.http.put<any>(url, data))
	}
	putAvatar(data: { avatar: any; avatar_provider: string; }) { 
		let url = `${environment.apiUrl}/user/avatar`;
		return this.retPipe(this.http.put<any>(url,data))
	}
	retPipe(obs: Observable<any>){
		return obs.pipe(map( response=>{return response;}) );
	  }
	  getMagicUser(magic: string) {
    	let url = `${environment.apiUrl}/user/magic/${magic}`;
    	return this.retPipe(this.http.get<any>(url))
  	}
    postMagicUser(magic: string, data:any) {
    	let url = `${environment.apiUrl}/user/magic/${magic}`;
    	return this.retPipe(this.http.post<any>(url, data))
  	}
	  addCustomerCard(card: any) {
		let url = `${environment.apiUrl}/user/customer/cards`;
		return this.retPipe(this.http.post<any>(url, card));
	}
	  putProfile(data: any) {
    	let url = `${environment.apiUrl}/user/profile`;
    	return this.retPipe(this.http.put<any>(url,data))
  	}
	  postVerifyWhatsapp(telephone?: string) {
    	let url = `${environment.apiUrl}/user/verify/profile/whatsapp`;
    	const body = telephone ? { telephone } : {};
    	return this.retPipe(this.http.post<any>(url, body))
  	}
	  putVerifyWhatsapp(data: { telephone: any; token: any; }) {
    	let url = `${environment.apiUrl}/user/verify/profile/whatsapp`;
    	return this.retPipe(this.http.put<any>(url, data))
  	}

	postUserConfiguration(data: any){
		let url = `${environment.apiUrl}/user/config`;
		return this.retPipe(this.http.post<any>(url,data))
	}

	getUserConfiguration(){
		let url = `${environment.apiUrl}/user/config`;
		return this.retPipe(this.http.get<any>(url))
	}

	postUserSkills(data: any){
		let url = `${environment.apiUrl}/user/skills`;
		return this.retPipe(this.http.post<any>(url,data))
	}

	getUserSkills(){
		let url = `${environment.apiUrl}/user/skills`;
		return this.retPipe(this.http.get<any>(url))
	}

	// ── Plantillas de nota médica: { id, name, text } ──────────────────────
	getUserTemplates(){
		let url = `${environment.apiUrl}/user/templates`;
		return this.retPipe(this.http.get<any>(url))
	}

	postUserTemplate(data: { name: string; text: string }){
		let url = `${environment.apiUrl}/user/templates`;
		return this.retPipe(this.http.post<any>(url,data))
	}

	putUserTemplate(id: number, data: { name: string; text: string }){
		let url = `${environment.apiUrl}/user/template/${id}`;
		return this.retPipe(this.http.put<any>(url,data))
	}

	deleteUserTemplate(id: number){
		let url = `${environment.apiUrl}/user/template/${id}`;
		return this.retPipe(this.http.delete<any>(url))
	}

	  getLocations() {
		let url = `${environment.apiUrl}/user/locations`;
		return this.http.get<any>(url).pipe(
			map(
				response=> {return response;}
			)
		);
	  }
	  getUser() {
		let url = `${environment.apiUrl}/user`;
		return this.http.get<any>(url);
	}
	  getCustomer() {
		let url = `${environment.apiUrl}/user/customer`; 
		return this.http.get<any>(url);
	}
	  getUserMeta(key: string) {
		let url = `${environment.apiUrl}/user/meta`; 
		let params = new HttpParams();
		params = params.append('key', key);
		return this.http.get<any>(url, {params:params})
	}
	  deleteCustomerCard(id: string) {
		let url = `${environment.apiUrl}/user/customer/card/${id}`;
		return this.http.delete<any>(url);
	}
	getUserGroups(){
		let currentUser = JSON.parse(localStorage.getItem('currentUser') ||"{}");
		if(currentUser.groups){
			return currentUser.groups
		}		
	}
	getUserId(){
		let currentUser = JSON.parse(localStorage.getItem('currentUser') ||"{}");
		if(currentUser.id){
			return currentUser.id
		}		
	}
	getPaymentCards() {
		let url = `${environment.apiUrl}/user/customer/cards`; 
		return this.http.get<any>(url);
	}
	  updatePassword(old_password:string, new_password:string){
		const endpoint = `${environment.apiUrl}/user/password` ;
		let lc = localStorage.getItem('currentUser') || '{}'
		let currentUser = JSON.parse(lc);
		let access = currentUser.access;
		let refresh = currentUser.refresh;
		let data = {old_password, new_password, access, refresh}
		return this.retPipe(this.http.put(endpoint, data))
	   }
	  deleteCustomerSubscription(id: any) {
		let url = `${environment.apiUrl}/user/customer/subscription/${id}`;
		return this.http.delete<any>(url);
	}
	getCustomerSubscriptions() {
		let url = `${environment.apiUrl}/user/customer/subscriptions`; 
		return this.http.get<any>(url);
	}
  	getCustomerPayments() {
		let url = `${environment.apiUrl}/user/customer/payments`; 
		return this.http.get<any>(url);
	}
	postUserCreate(data: any):Observable<any> {
		let url = `${environment.apiUrl}/user/create`;
    return this.http.post<any>(url, data).pipe(
      map(
        response=>{return response;}
      )
    );
	}
	forgotPassword(email:string){
		const endpoint = `${environment.apiUrl}/user/email/recovery`;
		return this.retPipe(this.http.post(endpoint, {email}))
	}
	postCheckLicense(){
		let url = `${environment.apiUrl}/user/check/license`;
    	return this.retPipe(this.http.post<any>(url, undefined))
	}
	deleteEmailValidation(data: any): Observable<any> {
		let url = `${environment.apiUrl}/user/email/validation`;
		const options = {
			headers: new HttpHeaders({
			  'Content-Type': 'application/json',
			}),
			body: data,
		  };
		return this.retPipe(this.http.delete<any>(url, options))
    }
	confirmForgotPassword(email:string, token:string, password:string){
		const endpoint = `${environment.apiUrl}/user/email/recovery`;
		let headers = {'Content-Type': 'application/json'};
		let body = JSON.stringify({email, token, password});
		return this.retPipe(this.http.request('delete', endpoint, {headers, body}))
	}
	resendEmailValidation(data: any): Observable<any> {
		let url = `${environment.apiUrl}/user/email/resendvalidation`;
		return this.retPipe(this.http.post<any>(url,data))
    }

	getUserPlans(planType: any, timeUnit: string) {
		let url = `${environment.apiUrl}/user/plans`;
		let params = new HttpParams();
		params = params.append('type', planType);
		params = params.append('frequency', timeUnit);
		return this.http.get<any>(url, {params:params})
	}

	postRegister(data: any): Observable<any> {
		let url = `${environment.apiUrl}/user/register`;
		return this.retPipe(this.http.post<any>(url, data))
    }

}
